module.exports = __webpack_public_path__ + "img/pet-details.2994e8a0.png";